import classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface IProps {
    text?: string;
    className?: string;
    visible?: boolean;
    useChildrenAsText?: boolean;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

export const Loading: FC<IProps> = ({ text, className, style, visible = true, children, useChildrenAsText = false }) => {
    const { t } = useTranslation();
    if (!visible) {
        return <>{children}</>;
    }
    return <div className={classNames('d-flex align-items-center', className)} style={style}>
        <div className="spinner-border me-2" role="status" aria-hidden="true"></div>
        <strong> {useChildrenAsText ? children : text || t('common:Loading.Loading')} </strong>
    </div>;
};

export const ServiceLoader: FC<IProps> = ({ visible = true, children }) => {
    if (!visible) {
        return <>{children}</>;
    }
    return <div className="service-loader d-flex flex-column position-absolute">
        <div className="service-loader-logo"></div>
        <div className="progress progress-sm progress-container">
            <div className="progress-bar animated-progress" role="progressbar"></div>
        </div>
    </div>;
};
